import { gql } from "apollo-boost";

export const COUNT_VISITER = gql`
    query CountSiter {
    countSiter {
        count 
    }
    }
`